module.exports = [
	{
	"featureType": "poi",
	"stylers": [
	  { "visibility": "off" }
	]
	},{
	"featureType": "landscape",
	"stylers": [
	  { "saturation": -100 }
	]
	},{
	"featureType": "road.highway",
	"elementType": "geometry.fill",
	"stylers": [
	  { "color": "#7B7B7B" }
	]
	},{
	"featureType": "road",
	"elementType": "labels.text.fill",
	"stylers": [
	  { "color": "#7B7B7B" }
	]
	},{
    "featureType": "road.arterial",
    "elementType": "geometry.stroke",
    "stylers": [
      { "color": "#888" }
    ]
  },{
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      { "color": "#888" }
    ]
  }
]



//////////////////
// WEBPACK FOOTER
// ./~/cltvo-maps/cltvo-grey-map-styles.js
// module id = 333
// module chunks = 1